import { http } from './http';
import type { AxiosRequestConfig } from 'axios';

export type Album = {
  id: string;
  name: string;
  description: string;
  lastUpdate: string;
  cover: string;
  chapters: Array<{
    id: string;
    title: string;
    description: string;
    lastUpdate: string;
    readerId?: string;
  }>;
};

export type PagedAlbums = {
  items: Album[];
  total: number;
  page: number;
  pageSize: number;
};

export function getAlbums(page: number, pageSize: number, name: string | undefined, storieType: number) {
  return http.get('Storie/albuns', {
    params: {
      page,
      pageSize,
      ...(name ? { name } : {}),
      ...(storieType ? { storieType } : {}),
    },
  });
}

export type DownloadPayload = { chapterId: string };

/**
 * ===== Names expected by Reader (compat) =====
 * These are thin aliases to your backend endpoints.
 */
export function getChapterByIndex(chapterId: string, config?: AxiosRequestConfig) {
  return http.get('Storie/chapter-id', {
    ...config,
    params: { ...(config?.params as any), chapterId },
  });
}

export function getChapterFreeByIndex(chapterId: string, config?: AxiosRequestConfig) {
  return http.get('Storie/free-chapter-id', {
    ...config,
    params: { ...(config?.params as any), chapterId },
  });
}

export function getDownloadLinkByChapterId(
  payload: DownloadPayload,
  onDownloadProgress?: (e: any) => void,
  signal?: AbortSignal
) {
  return http.post('Storie/download', payload, {
    responseType: 'blob',
    onDownloadProgress,
    timeout: 0,
    signal,
    maxContentLength: Infinity,
    maxBodyLength: Infinity
  });
}

export function getDownloadFreeLinkByChapterId(
  payload: DownloadPayload,
  onDownloadProgress?: (e: any) => void,
  signal?: AbortSignal
) {
  return http.post('Storie/free-download', payload, {
    responseType: 'blob',
    onDownloadProgress,
    timeout: 0,
    signal,
  });
}

/**
 * ===== Preferred API (new names) =====
 */
export function getChapterById(chapterId?: string, config?: AxiosRequestConfig) {
  if (!chapterId) return http.get('Storie/chapter-id', { ...config });
  return getChapterByIndex(chapterId, config);
}

export function getFreeChapterById(chapterId?: string, config?: AxiosRequestConfig) {
  if (!chapterId) return http.get('Storie/free-chapter-id', { ...config });
  return getChapterFreeByIndex(chapterId, config);
}

export function downloadChapter(
  payload: DownloadPayload,
  onDownloadProgress?: (e: any) => void,
  signal?: AbortSignal
) {
  return getDownloadLinkByChapterId(payload, onDownloadProgress, signal);
}

export function downloadFreeChapter(
  payload: DownloadPayload,
  onDownloadProgress?: (e: any) => void,
  signal?: AbortSignal
) {
  return getDownloadFreeLinkByChapterId(payload, onDownloadProgress, signal);
}
